import { Popup, PopupSettings } from 'components/common/popup/Popup';
import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import { Breakpoint } from '@mui/material';

export interface IInfoPopup {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    title: string;
    onHide?: () => void;
    content: any;
    setContent: (value: any) => void;
}

export function useInfoPopup(onHide?: () => void, defaultContent?: any): IInfoPopup {
    const { t } = useBundleTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState(defaultContent);
    const title = t('info');
    return {
        isOpen,
        setIsOpen,
        title,
        onHide,
        content,
        setContent,
    };
}

export function InfoPopupWrapper({ infoPopup }: { infoPopup: IInfoPopup }) {
    const handleOnHide = () => {
        infoPopup.setIsOpen(false);
        if (infoPopup.onHide) {
            infoPopup.onHide();
        }
    };

    return (
        <InfoPopup title={infoPopup.title} onHide={handleOnHide} isOpen={infoPopup.isOpen}>
            {infoPopup.content}
        </InfoPopup>
    );
}

export function InfoPopup({
    title,
    isOpen,
    children,
    onHide,
    maxWidth,
}: {
    title: string;
    isOpen: boolean;
    children: any;
    onHide: () => void;
    maxWidth?: Breakpoint | false;
}) {
    const popupSettings: PopupSettings = {
        title: title,
        needTranslation: false,
        noCancel: true,
        textOK: 'OK',
    };

    return (
        <Popup maxWidth={maxWidth} onHide={onHide} settings={popupSettings} open={isOpen}>
            {children}
        </Popup>
    );
}
